module.exports = __webpack_public_path__ + "static/media/cafes.7a9ffe27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityBadge/icons/cafes.svg
// module id = 293
// module chunks = 0